import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import {
  UpdateSparePartListing,
  AddMedia,
  getSparePartListing,
} from './../../../../Redux/Actions/UserAction';

import React from 'react';
import Sidebar from '../../../common/Sidebar/Sidebar';
import { timeOptions } from '../../../../Options';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';

const openStatus = ['OPEN', 'مفتوح'];

export default function SparePartsWorkingHours() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const home = useSelector((state) => state?.home);
  const SparePartList = home?.SparePartList?.[0];
  const getMybusiness = home?.getMybusiness;

  // After a save the action reloads the page, which wipes the store. The
  // business id arrives either from Redux (getMybusiness) or from
  // sessionStorage (set by the Header once /business/my resolves) — fetch the
  // owner's listing as soon as it's known so the form repopulates.
  const ownerBid =
    (getMybusiness?.businessId && String(getMybusiness.businessId)) ||
    sessionStorage.getItem('BusinessId');
  const validBid =
    ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null' && ownerBid !== '';

  const [SparePartData, setSparePartData] = useState({
    // businessId: '',
    calendar: {
      SUNDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      MONDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      TUESDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      WEDNESDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      THURSDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      FRIDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
      SATURDAY: {
        status: '',
        openTime: '',
        endTime: '',
      },
    },
  });

  const handleChange = (e) => {
    if (e.target.id === 'SUNDAY') {
      setSparePartData({
        ...SparePartData,
        calendar: {
          ...SparePartData.calendar,
          SUNDAY: {
            ...SparePartData.calendar.SUNDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'MONDAY') {
      setSparePartData({
        ...SparePartData,
        calendar: {
          ...SparePartData.calendar,
          MONDAY: {
            ...SparePartData.calendar.MONDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'TUESDAY') {
      setSparePartData({
        ...SparePartData,
        calendar: {
          ...SparePartData.calendar,
          TUESDAY: {
            ...SparePartData.calendar.TUESDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'WEDNESDAY') {
      setSparePartData({
        ...SparePartData,
        calendar: {
          ...SparePartData.calendar,
          WEDNESDAY: {
            ...SparePartData.calendar.WEDNESDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'THURSDAY') {
      setSparePartData({
        ...SparePartData,
        calendar: {
          ...SparePartData.calendar,
          THURSDAY: {
            ...SparePartData.calendar.THURSDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'FRIDAY') {
      setSparePartData({
        ...SparePartData,
        calendar: {
          ...SparePartData.calendar,
          FRIDAY: {
            ...SparePartData.calendar.FRIDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    } else if (e.target.id === 'SATURDAY') {
      setSparePartData({
        ...SparePartData,
        calendar: {
          ...SparePartData.calendar,
          SATURDAY: {
            ...SparePartData.calendar.SATURDAY,
            [e.target.name]: e.target.value,
          },
        },
      });
    }
  };

  useEffect(() => {
    if (validBid) {
      dispatch(getSparePartListing(ownerBid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerBid]);

  useEffect(() => {
    if (SparePartList && Object.keys(SparePartList).length > 0) {
      let calendar;
      try {
        calendar =
          typeof SparePartList?.calendar === 'string'
            ? JSON.parse(SparePartList?.calendar)
            : SparePartList?.calendar;
      } catch (e) {
        calendar = undefined;
      }
      setSparePartData({
        calendar: {
          SUNDAY: {
            status: calendar?.SUNDAY?.status,
            openTime: calendar?.SUNDAY?.openTime,
            endTime: calendar?.SUNDAY?.endTime,
          },
          MONDAY: {
            status: calendar?.MONDAY?.status,
            openTime: calendar?.MONDAY?.openTime,
            endTime: calendar?.MONDAY?.endTime,
          },
          TUESDAY: {
            status: calendar?.TUESDAY?.status,
            openTime: calendar?.TUESDAY?.openTime,
            endTime: calendar?.TUESDAY?.endTime,
          },
          WEDNESDAY: {
            status: calendar?.WEDNESDAY?.status,
            openTime: calendar?.WEDNESDAY?.openTime,
            endTime: calendar?.WEDNESDAY?.endTime,
          },
          THURSDAY: {
            status: calendar?.THURSDAY?.status,
            openTime: calendar?.THURSDAY?.openTime,
            endTime: calendar?.THURSDAY?.endTime,
          },
          FRIDAY: {
            status: calendar?.FRIDAY?.status,
            openTime: calendar?.FRIDAY?.openTime,
            endTime: calendar?.FRIDAY?.endTime,
          },
          SATURDAY: {
            status: calendar?.SATURDAY?.status,
            openTime: calendar?.SATURDAY?.openTime,
            endTime: calendar?.SATURDAY?.endTime,
          },
        },
      });
    }
  }, [SparePartList]);

  const datasubmit = () => {
    console.log('tihs is image section', SparePartData);
    dispatch(UpdateSparePartListing(SparePartData));
  };
  const ResetHendler = () => {
    setSparePartData({
      calendar: {
        SUNDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        MONDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        TUESDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        WEDNESDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        THURSDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        FRIDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
        SATURDAY: {
          status: 'CLOSE',
          openTime: '',
          endTime: '',
        },
      },
    });
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-spare-parts-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-spare-parts-parts',
      label: t('Manage Parts'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-spare-parts-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-spare-parts-working-hours',
      label: t('Manage Working Hours'),
    },
  ];

  console.log('89SparePartList', SparePartList, SparePartData);

  const isPaymentPlanActive = sessionStorage.getItem('paymentPlan');

  return (
    <div>
      <CommonBusinessHeader
        dataList={[SparePartList]}
        getNameKey="sparePartOwnerName"
      />
      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />
            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h2 class="mb-4">{t('Manage Working Hours')}</h2>
              <form onSubmit={handleSubmit(datasubmit)}>
                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Day')}</div>
                    </div>
                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="mwh-day">{t('From')}</label>
                    </div>
                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="mwh-day">{t('To')}</label>
                    </div>
                  </div>
                </div>
                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Sunday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="SUNDAY"
                        value={SparePartData.calendar.SUNDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.SUNDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="SUNDAY"
                        name="endTime"
                        value={SparePartData.calendar.SUNDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.SUNDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                SparePartData.calendar.SUNDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="SUNDAY"
                            onChange={(checked) => {
                              setSparePartData({
                                ...SparePartData,
                                calendar: {
                                  ...SparePartData.calendar,
                                  SUNDAY: {
                                    ...SparePartData.calendar.SUNDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox1'
														value='option1'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Monday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="MONDAY"
                        value={SparePartData.calendar.MONDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.MONDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="MONDAY"
                        name="endTime"
                        value={SparePartData.calendar.MONDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.MONDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                SparePartData.calendar.MONDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="MONDAY"
                            onChange={(checked) => {
                              setSparePartData({
                                ...SparePartData,
                                calendar: {
                                  ...SparePartData.calendar,
                                  MONDAY: {
                                    ...SparePartData.calendar.MONDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Tuesday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="TUESDAY"
                        value={SparePartData.calendar.TUESDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.TUESDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="TUESDAY"
                        name="endTime"
                        value={SparePartData.calendar.TUESDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.TUESDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                SparePartData.calendar.TUESDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="TUESDAY"
                            onChange={(checked) => {
                              setSparePartData({
                                ...SparePartData,
                                calendar: {
                                  ...SparePartData.calendar,
                                  TUESDAY: {
                                    ...SparePartData.calendar.TUESDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox3'
														value='option3'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Wednesday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="WEDNESDAY"
                        value={SparePartData.calendar.WEDNESDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.WEDNESDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="WEDNESDAY"
                        name="endTime"
                        value={SparePartData.calendar.WEDNESDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.WEDNESDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                SparePartData.calendar.WEDNESDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="WEDNESDAY"
                            onChange={(checked) => {
                              setSparePartData({
                                ...SparePartData,
                                calendar: {
                                  ...SparePartData.calendar,
                                  WEDNESDAY: {
                                    ...SparePartData.calendar.WEDNESDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox4'
														value='option4'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Thursday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="THURSDAY"
                        value={SparePartData.calendar.THURSDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.THURSDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="THURSDAY"
                        name="endTime"
                        value={SparePartData.calendar.THURSDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.THURSDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                SparePartData.calendar.THURSDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="THURSDAY"
                            onChange={(checked) => {
                              setSparePartData({
                                ...SparePartData,
                                calendar: {
                                  ...SparePartData.calendar,
                                  THURSDAY: {
                                    ...SparePartData.calendar.THURSDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox5'
														value='option5'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Friday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="FRIDAY"
                        value={SparePartData.calendar.FRIDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.FRIDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="FRIDAY"
                        name="endTime"
                        value={SparePartData.calendar.FRIDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.FRIDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                SparePartData.calendar.FRIDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="FRIDAY"
                            onChange={(checked) => {
                              setSparePartData({
                                ...SparePartData,
                                calendar: {
                                  ...SparePartData.calendar,
                                  FRIDAY: {
                                    ...SparePartData.calendar.FRIDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox6'
														value='option6'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mwh-row">
                  <div class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-day">{t('Saturday')}</div>
                    </div>

                    <div class="col-5 col-sm-5 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        name="openTime"
                        id="SATURDAY"
                        value={SparePartData.calendar.SATURDAY.openTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.SATURDAY.status
                          )
                        }
                      >
                        <option>{t('From')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <label class="sr-only">{t('From')}</label>
                      <select
                        class="form-control"
                        id="SATURDAY"
                        name="endTime"
                        value={SparePartData.calendar.SATURDAY.endTime}
                        onChange={handleChange}
                        disabled={
                          !openStatus.includes(
                            SparePartData.calendar.SATURDAY.status
                          )
                        }
                      >
                        <option>{t('To')}</option>
                        {timeOptions?.map((opt, index) => (
                          <option key={index}>{opt?.label}</option>
                        ))}
                      </select>
                    </div>

                    <div class="col-3 col-sm-3 col-md-3 mb-2 mb-sm-2 mb-md-0">
                      <div class="mwh-switch">
                        <div class="form-check form-check-inline">
                          <BootstrapSwitchButton
                            width={70}
                            checked={
                              openStatus.includes(
                                SparePartData.calendar.SATURDAY.status
                              )
                                ? true
                                : false
                            }
                            onstyle="warning"
                            onlabel={t('open')}
                            offlabel={t('close')}
                            name="status"
                            id="SATURDAY"
                            onChange={(checked) => {
                              setSparePartData({
                                ...SparePartData,
                                calendar: {
                                  ...SparePartData.calendar,
                                  SATURDAY: {
                                    ...SparePartData.calendar.SATURDAY,

                                    status: checked ? 'OPEN' : 'CLOSE',
                                  },
                                },
                              });
                            }}
                          />
                          {/* <input
														class='form-check-input'
														type='checkbox'
														id='inlineCheckbox7'
														value='option7'
													/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-5 ">
                  <div class="col-6">
                    <button
                      type="reset"
                      // onClick={ResetHendler}
                      class="btn btn-secondary btn-block"
                      href="#"
                      onClick={ResetHendler}
                      // role='button'
                    >
                      {t('Reset')}
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      type="submit"
                      // to='/sp-garages-packages'
                      class="btn btn-block btn-warning"
                      // href='sp-garages-manage-business-packages.html'
                      // role='button'
                    >
                      {t('Submit')}
                    </button>
                    {/* {isPaymentPlanActive == 'true' ? (
                    ) : (
                      <a
                        class="btn btn-warning btn-block"
                        href="#/manage-package"
                        role="button"
                      >
                        Buy Subscription
                      </a>
                    )} */}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
